import React, { useState } from "react";
import BasicModal from "../../core/BaseComponents/Modal";
import { FileUploader } from "react-drag-drop-files";
// import LogoutIcon from "@mui/icons-material/Logout";
import { BsFiletypeXlsx } from "react-icons/bs";
import { Tooltip } from "@mui/material";
import { getChainIdLS } from "../../../utils/utils";
import axios from "axios";

const UploadCDSNs = (props) => {
    const [uploadCdsns, setUploadCdsns] = useState(false);
    const [uploadFile, setUploadFile] = useState();
    const [totalHeaderCdsnsCount, setTotalHeaderCdsnsCount] = useState({});
    const [successCdsns, setSuccessCdsns] = useState([]);
    const [uploadCdsnError, setUploadCdsnError] = useState("")

    const popupCloseHandler = () => {
        setUploadCdsns(false);
        setUploadFile();
        setTotalHeaderCdsnsCount({});
        props?.handleDataFromChild(successCdsns);
        setUploadCdsnError('');
    }

    const uploadOrDragFileHandler = (file) => {
        // if (file && file.type === 'text/csv') {
        setUploadFile(file);
        // setFileErrorMsg('');
        // } 
        // else {
        //     setFileErrorMsg('Please Upload .CSV file');
        // }

    }

    const uploadFileHandler = () => {
        // if (uploadFile && uploadFile.type === 'text/csv') {
        const formData = new FormData();
        formData.append("file", uploadFile);

        axios.post(`${process.env.REACT_APP_BASE_URL}/upload-csv`, formData, { headers: { Authorization: `Bearer ${localStorage.getItem("jwt")}`, chainId: getChainIdLS() }, responseType: "blob", })
            .then((response) => {
                setUploadFile('');
                setSuccessCdsns(JSON.parse(response.headers['success-cdsns']))
                let headerResponse = {
                    successCount: response.headers['success-count'],
                    failureCount: response.headers['failure-count'],
                    totalCount: response.headers['total-count']
                }
                const url = window.URL.createObjectURL(new Blob([response?.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                }));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `${uploadFile.name.slice(0, -5)}__CDSN_Upload_Result.xls`); // Set file name
                document.body.appendChild(link);
                link.click();
                // Clean up
                link.remove();
                window.URL.revokeObjectURL(url);
                setTotalHeaderCdsnsCount(headerResponse);
                setUploadCdsnError('');
            })
            .catch(async (error) => {
                const errorMessage = await error.response?.data?.text();
                setUploadCdsnError(JSON.parse(errorMessage)?.errorMessage);
                console.warn(error);
            });
        // } 
    }
    return (
        <>
            <Tooltip title="Upload CDSNs from Excel" arrow>
                <button type="button" className="disable-btn" onClick={() => setUploadCdsns(true)}>
                    {/* <LogoutIcon
                        className={`me-1 rotate-270`}
                    /> */}
                    Upload CDSNs from Excel
                </button>
            </Tooltip>
            {uploadCdsns && <BasicModal
                popupOpen={uploadCdsns}
                bodyMessage={
                    uploadCdsns && !Object?.keys(totalHeaderCdsnsCount).length > 0 ?
                        <>
                            <div className="file-upload">
                                <FileUploader
                                    name="file"
                                    accept=".xlsx"
                                    types={['xlsx']}
                                    multiple={false}
                                    handleChange={uploadOrDragFileHandler}
                                    classes="drag-file"
                                    children={
                                        <>
                                            <BsFiletypeXlsx />
                                            <p className="drag-text">
                                                Drag and drop your file here, or
                                                <span> Browse</span>
                                            </p>
                                            <p className="upload-text">To upload your File.</p>
                                        </>
                                    }
                                />
                                {uploadCdsnError && <p className="required">{uploadCdsnError}</p>}
                            </div>
                            {uploadFile && <p>Selected File : {uploadFile?.name}</p>}
                        </>
                        : <div className="upload-cdsns">
                            <p className="total-count">Total CDSNs: {totalHeaderCdsnsCount?.totalCount}</p>
                            <p className="success-count">CDSNs Fetched Successfully: {totalHeaderCdsnsCount?.successCount}</p>
                            <p className="failure-count">Error In CDSNs: {totalHeaderCdsnsCount?.failureCount}</p>
                            <p className="mt-3">To know more please check the downloaded excel file</p>
                        </div>
                }
                customcss={true}
                footer={
                    uploadCdsns && !Object?.keys(totalHeaderCdsnsCount).length > 0 ?
                        {
                            primaryButton: {
                                buttonName: "Cancel",
                                action: popupCloseHandler,
                                buttonPrimaryCustomCss: 'cancel-btn_new'
                            }
                            ,
                            secondaryButton: {
                                buttonName: "Upload",
                                action: uploadFileHandler,
                                buttonSecondaryCustomCss: `${uploadFile ? '' : 'btn-disable'}`
                            }
                        }
                        : {
                            secondaryButton: {
                                buttonName: "OK",
                                action: popupCloseHandler,
                                buttonPrimaryCustomCss: 'cancel-btn_new'
                            }
                        }
                }
            />}
        </>
    )
}

export default UploadCDSNs;